// building area types
export const SAVE_BUILDING_AREA_REQUEST = 'SAVE_BUILDING_AREA_REQUEST';
export const SAVE_BUILDING_AREA_SUCCESS = 'SAVE_BUILDING_AREA_SUCCESS';
export const SAVE_BUILDING_AREA_FAILURE = 'SAVE_BUILDING_AREA_FAILURE';

export const FETCH_BUILDING_AREAS_REQUEST = 'FETCH_BUILDING_AREAS_REQUEST';
export const FETCH_BUILDING_AREAS_SUCCESS = 'FETCH_BUILDING_AREAS_SUCCESS';
export const FETCH_BUILDING_AREAS_FAILURE = 'FETCH_BUILDING_AREAS_FAILURE';

export const DELETE_BUILDING_AREA_REQUEST = 'DELETE_BUILDING_AREA_REQUEST';
export const DELETE_BUILDING_AREA_SUCCESS = 'DELETE_BUILDING_AREA_SUCCESS';
export const DELETE_BUILDING_AREA_FAILURE = 'DELETE_BUILDING_AREA_FAILURE';

// category
export const SAVE_CATEGORY_REQUEST = 'SAVE_CATEGORY_REQUEST';
export const SAVE_CATEGORY_SUCCESS = 'SAVE_CATEGORY_SUCCESS';
export const SAVE_CATEGORY_FAILURE = 'SAVE_CATEGORY_FAILURE';

export const FETCH_CATEGORIES_REQUEST = 'FETCH_CATEGORIES_REQUEST';
export const FETCH_CATEGORIES_SUCCESS = 'FETCH_CATEGORIES_SUCCESS';
export const FETCH_CATEGORIES_FAILURE = 'FETCH_CATEGORIES_FAILURE';

export const DELETE_CATEGORY_REQUEST = 'DELETE_CATEGORY_REQUEST';
export const DELETE_CATEGORY_SUCCESS = 'DELETE_CATEGORY_SUCCESS';
export const DELETE_CATEGORY_FAILURE = 'DELETE_CATEGORY_FAILURE';

// subcategory
export const SAVE_SUBCATEGORY_REQUEST = 'SAVE_SUBCATEGORY_REQUEST';
export const SAVE_SUBCATEGORY_SUCCESS = 'SAVE_SUBCATEGORY_SUCCESS';
export const SAVE_SUBCATEGORY_FAILURE = 'SAVE_SUBCATEGORY_FAILURE';

export const FETCH_SUBCATEGORIES_REQUEST = 'FETCH_SUBCATEGORIES_REQUEST';
export const FETCH_SUBCATEGORIES_SUCCESS = 'FETCH_SUBCATEGORIES_SUCCESS';
export const FETCH_SUBCATEGORIES_FAILURE = 'FETCH_SUBCATEGORIES_FAILURE';

export const DELETE_SUBCATEGORY_REQUEST = 'DELETE_SUBCATEGORY_REQUEST';
export const DELETE_SUBCATEGORY_SUCCESS = 'DELETE_SUBCATEGORY_SUCCESS';
export const DELETE_SUBCATEGORY_FAILURE = 'DELETE_SUBCATEGORY_FAILURE';

// material category
export const SAVE_MATERIAL_CATEGORY_REQUEST = 'SAVE_MATERIAL_CATEGORY_REQUEST';
export const SAVE_MATERIAL_CATEGORY_SUCCESS = 'SAVE_MATERIAL_CATEGORY_SUCCESS';
export const SAVE_MATERIAL_CATEGORY_FAILURE = 'SAVE_MATERIAL_CATEGORY_FAILURE';

export const FETCH_MATERIAL_CATEGORIES_REQUEST =
  'FETCH_MATERIAL_CATEGORIES_REQUEST';
export const FETCH_MATERIAL_CATEGORIES_SUCCESS =
  'FETCH_MATERIAL_CATEGORIES_SUCCESS';
export const FETCH_MATERIAL_CATEGORIES_FAILURE =
  'FETCH_MATERIAL_CATEGORIES_FAILURE';

export const DELETE_MATERIAL_CATEGORY_REQUEST =
  'DELETE_MATERIAL_CATEGORY_REQUEST';
export const DELETE_MATERIAL_CATEGORY_SUCCESS =
  'DELETE_MATERIAL_CATEGORY_SUCCESS';
export const DELETE_MATERIAL_CATEGORY_FAILURE =
  'DELETE_MATERIAL_CATEGORY_FAILURE';

// material detail
export const SAVE_MATERIAL_DETAIL_REQUEST = 'SAVE_MATERIAL_DETAIL_REQUEST';
export const SAVE_MATERIAL_DETAIL_SUCCESS = 'SAVE_MATERIAL_DETAIL_SUCCESS';
export const SAVE_MATERIAL_DETAIL_FAILURE = 'SAVE_MATERIAL_DETAIL_FAILURE';

export const FETCH_MATERIAL_DETAILS_REQUEST = 'FETCH_MATERIAL_DETAILS_REQUEST';
export const FETCH_MATERIAL_DETAILS_SUCCESS = 'FETCH_MATERIAL_DETAILS_SUCCESS';
export const FETCH_MATERIAL_DETAILS_FAILURE = 'FETCH_MATERIAL_DETAILS_FAILURE';

export const DELETE_MATERIAL_DETAIL_REQUEST = 'DELETE_MATERIAL_DETAIL_REQUEST';
export const DELETE_MATERIAL_DETAIL_SUCCESS = 'DELETE_MATERIAL_DETAIL_SUCCESS';
export const DELETE_MATERIAL_DETAIL_FAILURE = 'DELETE_MATERIAL_DETAIL_FAILURE';

// building number
export const SAVE_BUILDING_NUMBER_REQUEST = 'SAVE_BUILDING_NUMBER_REQUEST';
export const SAVE_BUILDING_NUMBER_SUCCESS = 'SAVE_BUILDING_NUMBER_SUCCESS';
export const SAVE_BUILDING_NUMBER_FAILURE = 'SAVE_BUILDING_NUMBER_FAILURE';

export const FETCH_BUILDING_NUMBERS_REQUEST = 'FETCH_BUILDING_NUMBERS_REQUEST';
export const FETCH_BUILDING_NUMBERS_SUCCESS = 'FETCH_BUILDING_NUMBERS_SUCCESS';
export const FETCH_BUILDING_NUMBERS_FAILURE = 'FETCH_BUILDING_NUMBERS_FAILURE';

export const DELETE_BUILDING_NUMBER_REQUEST = 'DELETE_BUILDING_NUMBER_REQUEST';
export const DELETE_BUILDING_NUMBER_SUCCESS = 'DELETE_BUILDING_NUMBER_SUCCESS';
export const DELETE_BUILDING_NUMBER_FAILURE = 'DELETE_BUILDING_NUMBER_FAILURE';

// classification
export const SAVE_CLASSIFICATION_REQUEST = 'SAVE_CLASSIFICATION_REQUEST';
export const SAVE_CLASSIFICATION_SUCCESS = 'SAVE_CLASSIFICATION_SUCCESS';
export const SAVE_CLASSIFICATION_FAILURE = 'SAVE_CLASSIFICATION_FAILURE';

export const FETCH_CLASSIFICATIONS_REQUEST = 'FETCH_CLASSIFICATIONS_REQUEST';
export const FETCH_CLASSIFICATIONS_SUCCESS = 'FETCH_CLASSIFICATIONS_SUCCESS';
export const FETCH_CLASSIFICATIONS_FAILURE = 'FETCH_CLASSIFICATIONS_FAILURE';

export const DELETE_CLASSIFICATION_REQUEST = 'DELETE_CLASSIFICATION_REQUEST';
export const DELETE_CLASSIFICATION_SUCCESS = 'DELETE_CLASSIFICATION_SUCCESS';
export const DELETE_CLASSIFICATION_FAILURE = 'DELETE_CLASSIFICATION_FAILURE';

// country
export const SAVE_COUNTRY_REQUEST = 'SAVE_COUNTRY_REQUEST';
export const SAVE_COUNTRY_SUCCESS = 'SAVE_COUNTRY_SUCCESS';
export const SAVE_COUNTRY_FAILURE = 'SAVE_COUNTRY_FAILURE';

export const FETCH_COUNTRIES_REQUEST = 'FETCH_COUNTRIES_REQUEST';
export const FETCH_COUNTRIES_SUCCESS = 'FETCH_COUNTRIES_SUCCESS';
export const FETCH_COUNTRIES_FAILURE = 'FETCH_COUNTRIES_FAILURE';

export const DELETE_COUNTRY_REQUEST = 'DELETE_COUNTRY_REQUEST';
export const DELETE_COUNTRY_SUCCESS = 'DELETE_COUNTRY_SUCCESS';
export const DELETE_COUNTRY_FAILURE = 'DELETE_COUNTRY_FAILURE';

// currency
export const SAVE_CURRENCY_REQUEST = 'SAVE_CURRENCY_REQUEST';
export const SAVE_CURRENCY_SUCCESS = 'SAVE_CURRENCY_SUCCESS';
export const SAVE_CURRENCY_FAILURE = 'SAVE_CURRENCY_FAILURE';

export const FETCH_CURRENCIES_REQUEST = 'FETCH_CURRENCIES_REQUEST';
export const FETCH_CURRENCIES_SUCCESS = 'FETCH_CURRENCIES_SUCCESS';
export const FETCH_CURRENCIES_FAILURE = 'FETCH_CURRENCIES_FAILURE';

export const DELETE_CURRENCY_REQUEST = 'DELETE_CURRENCY_REQUEST';
export const DELETE_CURRENCY_SUCCESS = 'DELETE_CURRENCY_SUCCESS';
export const DELETE_CURRENCY_FAILURE = 'DELETE_CURRENCY_FAILURE';

// geoAreas
export const SAVE_GEO_AREA_REQUEST = 'SAVE_GEO_AREA_REQUEST';
export const SAVE_GEO_AREA_SUCCESS = 'SAVE_GEO_AREA_SUCCESS';
export const SAVE_GEO_AREA_FAILURE = 'SAVE_GEO_AREA_FAILURE';

export const FETCH_GEO_AREAS_REQUEST = 'FETCH_GEO_AREAS_REQUEST';
export const FETCH_GEO_AREAS_SUCCESS = 'FETCH_GEO_AREAS_SUCCESS';
export const FETCH_GEO_AREAS_FAILURE = 'FETCH_GEO_AREAS_FAILURE';

export const DELETE_GEO_AREA_REQUEST = 'DELETE_GEO_AREA_REQUEST';
export const DELETE_GEO_AREA_SUCCESS = 'DELETE_GEO_AREA_SUCCESS';
export const DELETE_GEO_AREA_FAILURE = 'DELETE_GEO_AREA_FAILURE';

// LANGUAGE
export const SAVE_LANGUAGE_REQUEST = 'SAVE_LANGUAGE_REQUEST';
export const SAVE_LANGUAGE_SUCCESS = 'SAVE_LANGUAGE_SUCCESS';
export const SAVE_LANGUAGE_FAILURE = 'SAVE_LANGUAGE_FAILURE';

export const FETCH_LANGUAGES_REQUEST = 'FETCH_LANGUAGES_REQUEST';
export const FETCH_LANGUAGES_SUCCESS = 'FETCH_LANGUAGES_SUCCESS';
export const FETCH_LANGUAGES_FAILURE = 'FETCH_LANGUAGES_FAILURE';

export const FETCH_ISO_LANGUAGES_REQUEST = 'FETCH_ISO_LANGUAGES_REQUEST';
export const FETCH_ISO_LANGUAGES_SUCCESS = 'FETCH_ISO_LANGUAGES_SUCCESS';
export const FETCH_ISO_LANGUAGES_FAILURE = 'FETCH_ISO_LANGUAGES_FAILURE';

export const DELETE_LANGUAGE_REQUEST = 'DELETE_LANGUAGE_REQUEST';
export const DELETE_LANGUAGE_SUCCESS = 'DELETE_LANGUAGE_SUCCESS';
export const DELETE_LANGUAGE_FAILURE = 'DELETE_LANGUAGE_FAILURE';

export const CLEAR_LANGUAGE_ERRORS = 'CLEAR_LANGUAGE_ERRORS';

// LOCATION NAME
export const SAVE_LOCATION_NAME_REQUEST = 'SAVE_LOCATION_NAME_REQUEST';
export const SAVE_LOCATION_NAME_SUCCESS = 'SAVE_LOCATION_NAME_SUCCESS';
export const SAVE_LOCATION_NAME_FAILURE = 'SAVE_LOCATION_NAME_FAILURE';

export const FETCH_LOCATION_NAMES_REQUEST = 'FETCH_LOCATION_NAMES_REQUEST';
export const FETCH_LOCATION_NAMES_SUCCESS = 'FETCH_LOCATION_NAMES_SUCCESS';
export const FETCH_LOCATION_NAMES_FAILURE = 'FETCH_LOCATION_NAMES_FAILURE';

export const DELETE_LOCATION_NAME_REQUEST = 'DELETE_LOCATION_NAME_REQUEST';
export const DELETE_LOCATION_NAME_SUCCESS = 'DELETE_LOCATION_NAME_SUCCESS';
export const DELETE_LOCATION_NAME_FAILURE = 'DELETE_LOCATION_NAME_FAILURE';

// SUBJECT
export const SAVE_SUBJECT_REQUEST = 'SAVE_SUBJECT_REQUEST';
export const SAVE_SUBJECT_SUCCESS = 'SAVE_SUBJECT_SUCCESS';
export const SAVE_SUBJECT_FAILURE = 'SAVE_SUBJECT_FAILURE';

export const FETCH_SUBJECTS_REQUEST = 'FETCH_SUBJECTS_REQUEST';
export const FETCH_SUBJECTS_SUCCESS = 'FETCH_SUBJECTS_SUCCESS';
export const FETCH_SUBJECTS_FAILURE = 'FETCH_SUBJECTS_FAILURE';

export const DELETE_SUBJECT_REQUEST = 'DELETE_SUBJECT_REQUEST';
export const DELETE_SUBJECT_SUCCESS = 'DELETE_SUBJECT_SUCCESS';
export const DELETE_SUBJECT_FAILURE = 'DELETE_SUBJECT_FAILURE';

// SURFACE
export const SAVE_SURFACE_REQUEST = 'SAVE_SURFACE_REQUEST';
export const SAVE_SURFACE_SUCCESS = 'SAVE_SURFACE_SUCCESS';
export const SAVE_SURFACE_FAILURE = 'SAVE_SURFACE_FAILURE';

export const FETCH_SURFACES_REQUEST = 'FETCH_SURFACES_REQUEST';
export const FETCH_SURFACES_SUCCESS = 'FETCH_SURFACES_SUCCESS';
export const FETCH_SURFACES_FAILURE = 'FETCH_SURFACES_FAILURE';

export const DELETE_SURFACE_REQUEST = 'DELETE_SURFACE_REQUEST';
export const DELETE_SURFACE_SUCCESS = 'DELETE_SURFACE_SUCCESS';
export const DELETE_SURFACE_FAILURE = 'DELETE_SURFACE_FAILURE';

// TECHNOLOGY
export const SAVE_TECHNOLOGY_REQUEST = 'SAVE_TECHNOLOGY_REQUEST';
export const SAVE_TECHNOLOGY_SUCCESS = 'SAVE_TECHNOLOGY_SUCCESS';
export const SAVE_TECHNOLOGY_FAILURE = 'SAVE_TECHNOLOGY_FAILURE';

export const FETCH_TECHNOLOGIES_REQUEST = 'FETCH_TECHNOLOGIES_REQUEST';
export const FETCH_TECHNOLOGIES_SUCCESS = 'FETCH_TECHNOLOGIES_SUCCESS';
export const FETCH_TECHNOLOGIES_FAILURE = 'FETCH_TECHNOLOGIES_FAILURE';

export const DELETE_TECHNOLOGY_REQUEST = 'DELETE_TECHNOLOGY_REQUEST';
export const DELETE_TECHNOLOGY_SUCCESS = 'DELETE_TECHNOLOGY_SUCCESS';
export const DELETE_TECHNOLOGY_FAILURE = 'DELETE_TECHNOLOGY_FAILURE';

// CONDITION_CAT
export const SAVE_CONDITION_CAT_REQUEST = 'SAVE_CONDITION_CAT_REQUEST';
export const SAVE_CONDITION_CAT_SUCCESS = 'SAVE_CONDITION_CAT_SUCCESS';
export const SAVE_CONDITION_CAT_FAILURE = 'SAVE_CONDITION_CAT_FAILURE';

export const FETCH_CONDITION_CATS_REQUEST = 'FETCH_CONDITION_CATS_REQUEST';
export const FETCH_CONDITION_CATS_SUCCESS = 'FETCH_CONDITION_CATS_SUCCESS';
export const FETCH_CONDITION_CATS_FAILURE = 'FETCH_CONDITION_CATS_FAILURE';

export const DELETE_CONDITION_CAT_REQUEST = 'DELETE_CONDITION_CAT_REQUEST';
export const DELETE_CONDITION_CAT_SUCCESS = 'DELETE_CONDITION_CAT_SUCCESS';
export const DELETE_CONDITION_CAT_FAILURE = 'DELETE_CONDITION_CAT_FAILURE';

// TREATMENT_CAT
export const SAVE_TREATMENT_CAT_REQUEST = 'SAVE_TREATMENT_CAT_REQUEST';
export const SAVE_TREATMENT_CAT_SUCCESS = 'SAVE_TREATMENT_CAT_SUCCESS';
export const SAVE_TREATMENT_CAT_FAILURE = 'SAVE_TREATMENT_CAT_FAILURE';

export const FETCH_TREATMENT_CATS_REQUEST = 'FETCH_TREATMENT_CATS_REQUEST';
export const FETCH_TREATMENT_CATS_SUCCESS = 'FETCH_TREATMENT_CATS_SUCCESS';
export const FETCH_TREATMENT_CATS_FAILURE = 'FETCH_TREATMENT_CATS_FAILURE';

export const DELETE_TREATMENT_CAT_REQUEST = 'DELETE_TREATMENT_CAT_REQUEST';
export const DELETE_TREATMENT_CAT_SUCCESS = 'DELETE_TREATMENT_CAT_SUCCESS';
export const DELETE_TREATMENT_CAT_FAILURE = 'DELETE_TREATMENT_CAT_FAILURE';

// MOVEMENT_REASON
export const SAVE_MOVEMENT_REASON_REQUEST = 'SAVE_MOVEMENT_REASON_REQUEST';
export const SAVE_MOVEMENT_REASON_SUCCESS = 'SAVE_MOVEMENT_REASON_SUCCESS';
export const SAVE_MOVEMENT_REASON_FAILURE = 'SAVE_MOVEMENT_REASON_FAILURE';

export const FETCH_MOVEMENT_REASONS_REQUEST = 'FETCH_MOVEMENT_REASONS_REQUEST';
export const FETCH_MOVEMENT_REASONS_SUCCESS = 'FETCH_MOVEMENT_REASONS_SUCCESS';
export const FETCH_MOVEMENT_REASONS_FAILURE = 'FETCH_MOVEMENT_REASONS_FAILURE';

export const DELETE_MOVEMENT_REASON_REQUEST = 'DELETE_MOVEMENT_REASON_REQUEST';
export const DELETE_MOVEMENT_REASON_SUCCESS = 'DELETE_MOVEMENT_REASON_SUCCESS';
export const DELETE_MOVEMENT_REASON_FAILURE = 'DELETE_MOVEMENT_REASON_FAILURE';
